// Hợp đồng
export default {
  // General: 0, // không chọn
  Purchase: 1, //'Hợp đồng mua',
  Sale: 2, //'Hợp đồng bán',
};
